export enum PERFORMANCE_SHEET_FIELD_TYPES {
  DATA = 'data',
  SEPARATOR = 'separator',
}

export enum PERFORMANCE_SHEET_STATUSES {
  LOCKED = 'Locked',
  DRAFT = 'Draft',
}
